import {StoreNamespace} from "@/globals/StoreNamespaceGlobal";
import {RootState} from '@/store'
import {EntitlementSimulatorState} from "@/store/modules/entitlement/index";
import {RequestPayload, ServiceApi} from "@payroll/optimus-common";
import {ActionTree} from 'vuex'

export const actions: ActionTree<EntitlementSimulatorState, RootState> = {

  fetchEntitlementSimulator: ({commit, dispatch, state, rootGetters}: any, {requestBody, requestorCallback}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName("fetchEntitlementSimulator")
      .setRequestBody(requestBody)
      .post(requestorCallback)
  },

  fetchInnerDataLoans: ({commit, dispatch, state, rootGetters}: any, {requestBody, requestorCallback}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName("fetchInnerDataLoans")
      .setRequestBody(requestBody)
      .post(requestorCallback)
  },

  getInnerDateStepOneEntitlementSimulator: ({commit, dispatch, state, rootGetters}: any, {requestBody, requestorCallback, pathVariable}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName("getInnerDateStepOneEntitlementSimulator")
      .setRequestBody(requestBody)
      .setPathVariable(pathVariable)
      .post(requestorCallback)
  },

  getLoanMonthOptions: ({commit, dispatch, state, rootGetters}: any, {requestBody, requestorCallback}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('getLoanMonthOptions')
      .setRequestBody(requestBody)
      .post(requestorCallback)
  },

  getFundTypeEntitlementSimulator: ({commit, dispatch, state, rootGetters}: any, {pathVariable, requestorCallback}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName("getFundTypeEntitlementSimulator")
      .setPathVariable(pathVariable)
      .get(requestorCallback)
  },
}
